import React from "react";
import { Box, Paper } from "@mui/material";
import TablePaperTrading from "./TablePaperTrading";

const TradeCapture = () => {
  return (
    <div className="page-body" style={{ paddingTop: 0 }}>
      <div className="container-fluid" style={{ paddingTop: 0 }}>
        <Box sx={{ width: "100%", mx: "auto", mt: 0, px: 1 }}>
          {/* ---- Content Section ---- */}
          <Paper
            elevation={0}
            sx={{
              backgroundColor: "#ffffff",
              p: 1,
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              minHeight: 200,
              width: "100%",
              overflowX: "auto",
              boxSizing: "border-box",
            }}
          >
            <Box sx={{ width: "100%", mt: 0, pt: 0 }}>
              <TablePaperTrading />
            </Box>
          </Paper>
        </Box>
      </div>
    </div>
  );
};

export default TradeCapture;
